import {
  successAction,
  types,
  errorAction,
  requestAction,
} from "@authzsvc/api-lib";

const initialState = {
  loading: false,
  data: [],
};

const searchApplications = (state = initialState, action) => {
  switch (action.type) {
    case errorAction(types.SEARCH_MY_APPLICATIONS):
    case errorAction(types.SEARCH_ALL_APPLICATIONS):
      return { ...state, loading: false };
    case successAction(types.SEARCH_MY_APPLICATIONS):
    case successAction(types.SEARCH_ALL_APPLICATIONS):
      return { ...state, data: action.payload.data, loading: false };
    case requestAction(types.SEARCH_MY_APPLICATIONS):
    case requestAction(types.SEARCH_ALL_APPLICATIONS):
      return { ...state, loading: true };
    default:
      return state;
  }
};

export default searchApplications;
